import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
import * as firebase from 'firebase';
import { 
  AngularFirestore 
} from 'angularfire2/firestore';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  bookid;
  authorname;
  cost;
  quantity;
  title;
  searcharray:any=[];
  updatearray:any=[];
  vieworder1:any=[];
  mode=true;
  check=null;
  tasksid;
  author2="";
  title2="";
  quantity2="";
  cost2="";
  bkid;
  quantityview=0;
  array;

  constructor(public db1: AngularFirestore,public db: AngularFireDatabase) {


    this.vieworder1 = db1.collection("returnbooks").valueChanges();
    this.array = db1.collection("books").valueChanges();

   }

   availbooks()
   {

    var y= document.getElementById("search");
    y.style.display = "none";
    
    var z= document.getElementById("update");
    z.style.display = "none";
  
    var z1= document.getElementById("vieworder");
    z1.style.display = "none";

    var z2= document.getElementById("myDIV");
    z2.style.display = "none";

    var x = document.getElementById("avail"); 
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
   }


  addbooks() {
    var y= document.getElementById("search");
    y.style.display = "none";
    
    var z= document.getElementById("update");
    z.style.display = "none";
  
    var z1= document.getElementById("vieworder");
    z1.style.display = "none";

    var z1= document.getElementById("avail");
    z1.style.display = "none";

    var x = document.getElementById("myDIV"); 
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

searchbooks() {
    var y= document.getElementById("myDIV");
    y.style.display = "none";
    
    var z= document.getElementById("update");
    z.style.display = "none";
  
    var z1= document.getElementById("vieworder");
    z1.style.display = "none";
  
    var z1= document.getElementById("avail");
    z1.style.display = "none";

  var x = document.getElementById("search"); 
  if (x.style.display === "none") {
      x.style.display = "block";
  } else {
      x.style.display = "none";
  }
}

bookupdate() {

    var y= document.getElementById("myDIV");
    y.style.display = "none";
    
    var z= document.getElementById("search");
    z.style.display = "none";
  
    var z1= document.getElementById("vieworder");
    z1.style.display = "none";
    
    var z1= document.getElementById("avail");
    z1.style.display = "none";

    var x = document.getElementById("update"); 
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}


vieworder() {
    var y= document.getElementById("myDIV");
    y.style.display = "none";
    
    var z= document.getElementById("search");
    z.style.display = "none";
  
    var z1= document.getElementById("update");
    z1.style.display = "none";

    var z1= document.getElementById("avail");
    z1.style.display = "none";

    var x = document.getElementById("vieworder"); 
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

addbooks1(){
    this.check=null;
    this.db1.collection("books").doc(this.bookid).set({
    bookid:this.bookid,
    title:this.title,
    authorname:this.authorname,
    cost:this.cost,
    quantity:this.quantity
})

this.check="ok";

}

check1()
{
    this.check=null;
}

search(value)
{
  this.searcharray.length=0;

  var docRef = this.db1.collection("books").doc(value);

docRef.ref.get().then((doc)=> {
    if (doc.exists) {
        // console.log("Document data:", doc.data());
        this.searcharray.push(doc.data());
        this.mode=true;
    } else {
        // doc.data() will be undefined in this case
        this.mode=false;
        console.log("No such document!");
    }
}).catch(function(error) {
    console.log("Error getting document:", error);
});}

updatetask(tasksid)
{
    this.tasksid=null;
    this.tasksid=tasksid;
    console.log(tasksid);
}
updatesearch(i)
{

    this.db1.collection("books").doc(this.tasksid).set({
        authorname: this.author2,
        bookid: this.tasksid,
        cost: this.cost2,
        quantity: this.quantity2,
        title: this.title2
    })

    .then(function() {
        console.log("Document successfully written!");
    })
    .catch(function(error) {
        console.error("Error writing document: ", error);
    });

    this.author2=""
    this.cost2=""
    this.quantity2=""
    this.title2=""
}

updatebooks1(value)
{
  this.updatearray.length=0;
  // var query=this.db1.collection('books', ref => ref.where('bookid', '==', value))
  // this.searcharray=query;
  // console.log(query)
  // return this.searcharray
  // console.log(query)
  var docRef = this.db1.collection("books").doc(value);

docRef.ref.get().then((doc)=> {
    if (doc.exists) {
        console.log("Document data:", doc.data());
        this.updatearray.push(doc.data());
        this.mode=true;
    } else {
        // doc.data() will be undefined in this case
        this.mode=false;
        console.log("No such document!");
    }
}).catch(function(error) {
    console.log("Error getting document:", error);
});


}

vieworderbooks(bkid,id){
// console.log("asdasd",bkid)
    var docRef = this.db1.collection("books").doc(bkid);
    docRef.ref.get().then((doc)=> {
    if (doc.exists) {
        // console.log("Document data:", doc.data().quantity);
        // this.quantityview=doc.data().quantity;
            this.db1.collection("books").doc(bkid).update({
        "quantity": doc.data().quantity+1
    })
    .then(()=> {
        console.log("Document successfully updated!");
        this.db1.collection("returnbooks").doc(id).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
    });

    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
}).catch(function(error) {
    console.log("Error getting document:", error);
});


}

  ngOnInit() {
  }

}
